(function () {
  var TRANSITION_DURATION = 300;
  var EASE = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
  var panelTimers = new WeakMap();

  function triggerLayoutUpdate() {
    window.setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('scroll'));
    }, TRANSITION_DURATION + 10);
  }

  function clearPanelTimer(panel) {
    var timerId = panelTimers.get(panel);
    if (timerId) {
      window.clearTimeout(timerId);
      panelTimers.delete(panel);
    }
  }

  function finishOpen(panel) {
    panel.style.height = 'auto';
    panel.style.overflow = '';
    panel.style.transition = '';
    panel.removeAttribute('aria-hidden');
    clearPanelTimer(panel);
  }

  function finishClose(panel) {
    panel.hidden = true;
    panel.style.height = '0px';
    panel.style.overflow = '';
    panel.style.transition = '';
    panel.setAttribute('aria-hidden', 'true');
    clearPanelTimer(panel);
  }

  function openItem(item, instant) {
    var button = item.querySelector('.amd-home-faq__question-text');
    var panel = item.querySelector('.amd-home-faq__question-inner');
    var icon = item.querySelector('.amd-home-faq__plus-minus');
    var iconWrapper = icon ? icon.parentElement : null;
    if (!button || !panel) return;

    clearPanelTimer(panel);
    item.classList.add('is-open');
    item.classList.add('active');
    button.classList.add('active');
    button.setAttribute('aria-expanded', 'true');
    if (icon) icon.classList.add('active');
    if (iconWrapper) iconWrapper.classList.add('active');

    if (instant) {
      panel.hidden = false;
      panel.style.height = 'auto';
      panel.style.overflow = '';
      panel.style.transition = '';
      panel.removeAttribute('aria-hidden');
      return;
    }

    panel.hidden = false;
    panel.style.overflow = 'hidden';
    panel.style.transition = 'none';
    panel.style.height = '0px';
    panel.offsetHeight;

    panel.style.transition = 'height ' + TRANSITION_DURATION + 'ms ' + EASE;
    panel.style.height = panel.scrollHeight + 'px';

    panelTimers.set(
      panel,
      window.setTimeout(function () {
        finishOpen(panel);
      }, TRANSITION_DURATION + 40)
    );

    triggerLayoutUpdate();
  }

  function closeItem(item, instant) {
    var button = item.querySelector('.amd-home-faq__question-text');
    var panel = item.querySelector('.amd-home-faq__question-inner');
    var icon = item.querySelector('.amd-home-faq__plus-minus');
    var iconWrapper = icon ? icon.parentElement : null;
    if (!button || !panel) return;

    clearPanelTimer(panel);
    item.classList.remove('is-open');
    item.classList.remove('active');
    button.classList.remove('active');
    button.setAttribute('aria-expanded', 'false');
    if (icon) icon.classList.remove('active');
    if (iconWrapper) iconWrapper.classList.remove('active');

    if (instant) {
      finishClose(panel);
      return;
    }

    if (!item.classList.contains('is-open') && panel.hidden) {
      finishClose(panel);
      return;
    }

    panel.hidden = false;
    panel.style.overflow = 'hidden';

    var startHeight = panel.scrollHeight;
    panel.style.transition = 'none';
    panel.style.height = startHeight + 'px';
    panel.offsetHeight;

    panel.style.transition = 'height ' + TRANSITION_DURATION + 'ms ' + EASE;
    panel.style.height = '0px';

    panelTimers.set(
      panel,
      window.setTimeout(function () {
        finishClose(panel);
      }, TRANSITION_DURATION + 40)
    );

    triggerLayoutUpdate();
  }

  function initFaqSection(section) {
    if (section.dataset.faqReady === 'true') return;
    section.dataset.faqReady = 'true';

    var allowMultiple = section.dataset.faqMultiple === 'true';
    var openFirst = section.dataset.faqOpenFirst === 'true';
    var items = Array.from(section.querySelectorAll('.amd-home-faq__question'));

    items.forEach(function (item, index) {
      var button = item.querySelector('.amd-home-faq__question-text');
      var panel = item.querySelector('.amd-home-faq__question-inner');
      if (!button || !panel) return;

      if (openFirst && index === 0) {
        openItem(item, true);
      } else {
        closeItem(item, true);
      }

      button.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (!allowMultiple) {
          items.forEach(function (otherItem) {
            if (otherItem !== item && otherItem.classList.contains('is-open')) {
              closeItem(otherItem, false);
            }
          });
        }

        if (isOpen) {
          closeItem(item, false);
        } else {
          openItem(item, false);
        }
      });
    });
  }

  function init(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.amd-home-faq');
    sections.forEach(initFaqSection);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
